import { main_api } from "../api/api";
import axios from "axios";

export const fetchMovies = async () => {
  try {
    const response = await axios.get(`${main_api}/movies`);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};